import { useState } from "react";

export default function FindPasswordForm({
  onVerify,
  onReset,
  verifyLoading,
  verifyError,
  verified,
  resetLoading,
  resetError,
}) {
  const [id, setId] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  const handleVerify = (e) => {
    e.preventDefault();
    if (!id) return alert("아이디를 입력해주세요.");
    if (!phone) return alert("전화번호를 입력해주세요.");
    if (!email) return alert("이메일을 입력해주세요.");
    onVerify({ id, phone_number: phone, email });
  };

  const handleReset = (e) => {
    e.preventDefault();
    if (!password || !passwordConfirm) return alert("새 비밀번호를 입력해주세요.");
    if (password.length < 4) return alert("비밀번호는 4자 이상이어야 합니다.");
    if (password !== passwordConfirm) return alert("비밀번호가 일치하지 않습니다.");
    onReset({ id, phone_number: phone, email, password });
  };

  return (
    <div className="login">
      <form onSubmit={verified ? handleReset : handleVerify} className="loginform">
        <div id="content_title">
          <h2>비밀번호 변경</h2>
        </div>

        <p>아이디</p>
        <input
          className="input_id"
          placeholder="아이디 입력"
          value={id}
          onChange={(e) => setId(e.target.value)}
          disabled={verified}
        />

        <p>전화번호</p>
        <input
          className="input_id"
          placeholder="010-1234-5678"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          disabled={verified}
        />

        <p>이메일</p>
        <input
          className="input_id"
          type="email"
          placeholder="이메일 입력"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={verified}
        />

        {!verified && (
          <>
            <button className="loginsubmit" disabled={verifyLoading}>
              {verifyLoading ? "확인 중…" : "회원 확인"}
            </button>
            {verifyError && <p className="error">{verifyError}</p>}
          </>
        )}

        {verified && (
          <>
            <p>새 비밀번호</p>
            <input
              className="input_pw"
              type="password"
              placeholder="새 비밀번호 입력"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <p>새 비밀번호 확인</p>
            <input
              className="input_pw"
              type="password"
              placeholder="새 비밀번호 확인"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
            />

            <button className="loginsubmit" disabled={resetLoading}>
              {resetLoading ? "변경 중…" : "비밀번호 변경"}
            </button>
            {resetError && <p className="error">{resetError}</p>}
          </>
        )}

        <div className="join_link"><a href="/login">로그인으로 돌아가기</a></div>
      </form>
    </div>
  );
}
